import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { useBanner } from "../../../contexts/banner.js";
import { useGroupCheckbox } from "../../../hooks/common/useGroupCheckbox.js";
import { Checkbox } from "../../common/checkbox.js";
const BannerDottedGroup = ({ group })=>{
    const { name } = group;
    const banner = useBanner();
    const { decision: { groupsFirstView }, design: { fontSize } } = banner;
    const isPro = process.env.PLUGIN_CTX === "pro";
    const showCheckbox = isPro && groupsFirstView;
    const groupCheckbox = useGroupCheckbox(group);
    return /*#__PURE__*/ _jsx(Fragment, {
        children: showCheckbox ? /*#__PURE__*/ _jsx(Checkbox, {
            ...groupCheckbox,
            fontSize: fontSize,
            children: name
        }) : /*#__PURE__*/ _jsxs("span", {
            children: [
                /*#__PURE__*/ _jsx("i", {}),
                /*#__PURE__*/ _jsx("span", {
                    children: name
                })
            ]
        })
    });
};
export { BannerDottedGroup };
